<template>
  <el-form ref="myform" :model="formData" :label-width="config.base.labelWidth" :rules="config.rules" v-loading="loading">
    
    <el-row v-for="row in config.item">
      <el-col :span="item.span == undefined ? 24 : item.span" v-for="item in row">

        <el-form-item :label="item.title" :prop="item.id" v-show="item.show == undefined ? true : formData[item.show.field] == item.show.val">

          <!-- <template v-if="item.type == 'multi'">
            <div class="x-form-multi">
              <div class="list">
                <div class="item" v-for="(it, index) in formData[item.id]">
                  <div class="it" v-for="multiItem in item.config.form.item">
                    <div class="tit">{{multiItem.title}}</div>
                    <div class="ipt">
                      <el-input v-if="multiItem.type == 'input'" v-model="it[multiItem.id]">
                      </el-input>
                    </div>
                  </div>
                  <div class="opt">
                    <el-button size="small" type="danger" icon="delete" @click="removeMultiItem(item.id, index)"></el-button>
                  </div>
                </div>
              </div>
              <div class="opt-add">
                <el-button size="small" icon="plus" @click="addMultiItem(item.id)">添加{{item.config.text}}</el-button>
              </div>
            </div>
          </template>
           -->
          <!-- base -->
          <el-input v-if="item.type == 'input'" v-model="formData[item.id]" :icon="item.config !== undefined && item.config.icon !== undefined ? item.config.icon : null">
            <template v-if="item.config !== undefined && item.config.prepend !== undefined" slot="prepend">{{item.config.prepend}}</template>
            <template v-if="item.config !== undefined && item.config.append !== undefined" slot="append">{{item.config.append}}</template>
          </el-input>

          <el-input-number v-if="item.type == 'number'" v-model="formData[item.id]" :min="item.config.min" :max="item.config.max" :step="item.config.step"></el-input-number>
          
          <el-rate v-if="item.type == 'rate'" v-model="formData[item.id]"></el-rate>

          <el-upload
            v-if="item.type == 'upload'"
            class="avatar-uploader"
            :action="item.config.action"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="formData.fitdata" :src="'http://www.888jigong.com/upload/orderimg/' + formData.fitdata" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

          <!-- multi change -->
          <el-select
            v-if="item.type == 'select'"
            v-model="formData[item.id]"
            :multiple="item.config == undefined || item.config.multiple == undefined ? false : item.config.multiple"
            :placeholder="item.placeholder">
            <el-option v-for="it in item.data" :label="it.text" :value="it.id"></el-option>
          </el-select>

          <xselect-remote
            v-if="item.type == 'select_remote'"
            v-model="formData[item.id]"
            :url="item.config.url"
            :text-field="item.config.textField"
            :value-field="item.config.valueField"
            :default-item="formData[item.id]"
            :placeholder="item.placeholder">
          </xselect-remote>

          <el-checkbox-group v-model="formData[item.id]" v-if="item.type == 'check'">
            <el-checkbox v-for="it in item.data" :label="it.id">{{it.text}}</el-checkbox>
          </el-checkbox-group>

          <el-radio-group v-model="formData[item.id]" v-if="item.type == 'radio'">
            <el-radio v-for="it in item.data" :label="it.id" v-if="item.config.type == undefined">{{it.text}}</el-radio>
            <el-radio-button v-for="it in item.data" :label="it.id" v-if="item.config.type=='btn'">{{it.text}}</el-radio-button>
          </el-radio-group>

          <el-switch v-if="item.type == 'switch'" on-text="" off-text="" v-model="formData[item.id]"></el-switch>

          <xcascader
            v-if="item.type == 'cascader'"
            v-model="formData[item.id]"
            :url="item.config.url"
            :value-field="item.config.valueField"
            :text-field="item.config.textField"
            :placeholder="item.placeholder">
          </xcascader>

          <!-- time -->
          <el-date-picker
            v-if="item.type == 'date'"
            v-model="formData[item.id]"
            :type="item.config.type"
            placeholder="选择日期">
          </el-date-picker>

          <!-- else -->
          <el-input v-if="item.type == 'textarea'" :autosize="item.config.autosize" :rows="item.config.rows" type="textarea" v-model="formData[item.id]"></el-input>

        </el-form-item>

      </el-col>
    </el-row>

    <el-form-item>
      <el-button type="primary" v-if="config.submit" @click="submit">{{config.submit.btnText}}</el-button>
    </el-form-item>

  </el-form>
</template>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>

<script>
import ajax from './ajax'
import XselectRemote from './select_remote.vue'
import Xcascader from './cascader.vue'

export default {
  name: 'xform',
  props: ['config', 'data', 'dataCopy'],
  data() {
    return {
      // upimgstatus: false,
      loading: true,
      selectQuery: {
        loading: false,
        list: []
      },
      formData: {}
    }
  },
  created(){
    this.getData();
  },
  watch: {
    data() {
      this.getData();
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.formData.fitdata = res.data.upload_data.file_name;
      // this.upimgstatus = true;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 4MB!');
      }
      return isJPG && isLt2M;
    },
    addMultiItem(id) {
      let item = {};
      for(let i in this.config.item){
        for(let n in this.config.item[i]){
          if(this.config.item[i][n].id == id){
            item = Object.assign(item, this.config.item[i][n].config.form.default);
            break;
          }
        }
      }
      this.formData[id].push(item);
    },
    removeMultiItem(id, index){
      this.formData[id].splice(index, 1);
    },
    getData() {
      if(typeof(this.data) == 'object'){
        if(this.dataCopy){
          this.formData = this.data;
        }else{
          this.formData = JSON.parse(JSON.stringify(this.data));
        }
        this.switchShift();
        this.initSelect();
        this.loading = false;
      }else if(typeof(this.data) == 'string'){
        let _self = this;
        ajax(this, 'get', this.data, {}, (res) => {
          // _self.formData = res.data;
          _self.formData = JSON.parse(JSON.stringify(res.data));
          _self.switchShift();
          _self.initSelect();
        }, () => {
          _self.loading = false;
        })
      }
    },
    switchShift(obj) {
      for(let i in this.config.item){
        for(let n in this.config.item[i]){
          if(this.config.item[i][n].type == 'switch'){
            let cid = this.config.item[i][n].id;
            if(obj == undefined){
              this.formData[cid] = (this.formData[cid] !== 0 && 
                this.formData[cid] !== false && 
                this.formData[cid] !== '0') ? true : false;
            }else{
              obj[cid] = (obj[cid]) ? '1' : '0';
            }
          }
        }
      }
    },
    initSelect() {
      for(let i in this.config.item){
        for(let n in this.config.item[i]){
          if(this.config.item[i][n].type == 'select' && typeof(this.config.item[i][n].data) == 'string'){
            let _self = this;
            ajax(this, 'get', this.config.item[i][n].data, {}, (res) => {
              _self.config.item[i][n].data = {};
              _self.config.item[i][n].data = res.data;
            })
          }
        }
      }
    },
    submit() {
      this.$refs.myform.validate((valid) => {
        if (valid) {
          this.loading = true;
          let _self = this;
          let submitData = JSON.parse(JSON.stringify(this.formData));
          this.switchShift(submitData);
          ajax(this, 'post', this.config.submit.url, submitData, (res) => {
            _self.$message({
              showClose: true,
              message: '操作成功',
              type: 'success'
            });
            _self.$emit('submitSuccess');
            _self.getData();
          }, () => {
            _self.loading = false;
          })
        }
      });
    }
  },
  components: {
    XselectRemote,
    Xcascader
  }
}
</script>



// WEBPACK FOOTER //
// form.vue?c5207cbc